module.exports = __webpack_public_path__ + "static/media/livechatHero.680d33b7.png";